module.exports = __webpack_public_path__ + "img/hero_oats.e9db4375.jpg";